import { useState, useEffect } from 'react';
import { getUserCreatedPuzzles } from '../services/api';

/**
 * The user's created puzzles, split into pending and private, for the
 * CreatedPuzzles modal. Fetched each time `isOpen` becomes true.
 *
 * @param {boolean} isOpen - whether the modal is open
 * @returns {{ pendingPuzzles: Array, privatePuzzles: Array, loading: boolean, error: string|null }}
 */
export const useCreatedPuzzles = (isOpen) => {
  const [pendingPuzzles, setPendingPuzzles] = useState([]);
  const [privatePuzzles, setPrivatePuzzles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Fetch created puzzles when modal opens
  useEffect(() => {
    if (isOpen) {
      fetchCreatedPuzzles();
    }
  }, [isOpen]);

  const fetchCreatedPuzzles = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await getUserCreatedPuzzles();

      // Set pending and private puzzles separately
      setPendingPuzzles(data.pending_puzzles || []);
      setPrivatePuzzles(data.private_puzzles || []);
    } catch (err) {
      console.error('Error fetching created puzzles:', err);
      setError('Failed to load created puzzles');
    } finally {
      setLoading(false);
    }
  };

  return { pendingPuzzles, privatePuzzles, loading, error };
};

export default useCreatedPuzzles;
